import { render, staticRenderFns } from "./ModalGiftCardOrderItemForm.vue?vue&type=template&id=3040e50c&"
import script from "./ModalGiftCardOrderItemForm.vue?vue&type=script&lang=js&"
export * from "./ModalGiftCardOrderItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports